var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.FastLoading,{tag:"component"}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$store.state.fastCarregando),expression:"!$store.state.fastCarregando"}],staticClass:"fdn-home"},[_c(_vm.CadastroAlunoContent,{tag:"component"}),_c(_vm.HomeFooter,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }